import React, { useEffect, useState, useRef } from "react";
import UploadIcon from "../../assets/images/UploadIcon.png";
import api from "../../api/config";
import { useFormContext } from "../../context/FormContext";
import { validatePropertyFilesUpload } from "../../validators/providers/AddBusiness";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ImagePreview from "./ImagePreview";



const PropertyFileUploadForm = ({
  providerDetail,
  params,
  temp,
  setTemp,
  loadingState,
}) => {
  useEffect(() => {
    const data = localStorage.getItem("data");
    console.log("localStorage.data on page load:", data);
  }, []); // ← 페이지 로드 시 딱 1번 실행
  
  const data = localStorage.getItem("data");
  let jwt = null;
  
  if (data) {
    try {
      jwt = JSON.parse(data)?.jwt;
    } catch (e) {}
  }
  
  const isGuest = !jwt;

  const [images, setImages] = useState([]);
  const [imagesURL, setImagesURL] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  //const isGuest = localStorage.getItem("role") === "Guest";
  const [errors, setErrors] = useState({
    images: "",
    email: "",
    phone: "",
  });

  const fileInputRef = useRef(null);

  const navigate = useNavigate();

  const { formData, setFormData } = useFormContext();

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setImages((prevImages) => [...prevImages, ...selectedFiles]);
  };

  useEffect(() => {    
    if (isSubmitting) {
      validateForm();
    }
  }, [images, email, phone]);

  const validateForm = () => {
    let newErrors = { images: "", email: "", phone: "" };

    if (params.type === "new") {
      newErrors.images = validatePropertyFilesUpload(images.length > 0, "images");
    } else if (params.type !== "new") {
      if (!imagesURL.length > 0) {
        newErrors.images = validatePropertyFilesUpload(images.length > 0, "images");
      }
    }

    if (isGuest) {
      newErrors.email = validatePropertyFilesUpload(email, "email");
      newErrors.phone = validatePropertyFilesUpload(phone, "phone");
    }

    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === "");
  };

  useEffect(() => {
    if (params?.type !== "new") {
      setFormData({
        ...formData,
        propertyBasic: {
          ...formData.propertyBasic,
          spaceFeedId: Number(params?.type),
        },
      });
    }
  }, [params]);

  const handleSubmit = async () => {
    setLoading(true);
    setIsSubmitting(true);
  
    const isFormValid = validateForm();
    if (!isFormValid) {
      setLoading(false);
      setIsSubmitting(false);
      return;
    }
  
    console.log("FINAL formData before submit:", formData);
    console.log("images before submit:", images);
    console.log("imagesURL before submit:", imagesURL);

    const freshImages = [...images];   // stale state 방지

    // 핵심: Proxy → 순수 객체로 변환
    //const pureData = JSON.parse(JSON.stringify(formData));
    const pureData = JSON.parse(JSON.stringify(formData));

    delete pureData.contactInfo;
    
    const formDatas = new FormData();

    const payload = {
      propertyBasic: pureData.propertyBasic,
      propertyDetails: pureData.propertyDetails,
      ...(isGuest && { email, phone }),
    };

    formDatas.append("data", JSON.stringify(payload));

    console.log("pureData:", pureData);

    
    //formDatas.append(
    //  "data",
    //  new Blob([JSON.stringify(pureData)], { type: "application/json" })
    //);
        
    //formDatas.append("data", JSON.stringify(pureData));   // 이제 절대 null 안 됨

    if (freshImages.length > 0) {
      freshImages.forEach(image => formDatas.append("files", image));
    }

    //const freshImages = [...images];   // stale state 방지
  
    //const formDatas = new FormData();
    //formDatas.append("data", JSON.stringify(formData));
  
    //if (freshImages.length > 0) {
    //  freshImages.forEach(image => formDatas.append("files", image));
    //}
  
    try {
      const response = await api.post("/create-space-feed", formDatas);
      if (response.status === 200) {
        toast.success("Submitted Successfully");
        const role = localStorage.getItem("role");
        setTimeout(() => {
          navigate(role === "Guest" ? "/" : "/provider-listing");
        }, 2000);
      }
    } catch (error) {
      console.log(error, "error");
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  
  /*
  const handleSubmit = async () => {
    const emptyFile = new File([], "empty.txt", { type: "text/plain" });
    setLoading(true);
    setIsSubmitting(true);
    const isFormValid = validateForm();
    if (isFormValid) {
      setIsSubmitting(false);
      //setFormData({
      //  ...formData,
      //});

      // create-space-feed 호출 직전에 formData를 찍어야 한다
      console.log("FINAL formData before submit:", formData);
      console.log("images before submit:", images);
      console.log("imagesURL before submit:", imagesURL);

      const formDatas = new FormData();
      formDatas.append("data", JSON.stringify(formData));
      if (images.length > 0) {
        images.forEach((image, index) => {
          formDatas.append(`files`, image);
        });
      } else {
        formDatas.append(`files`, emptyFile);
      }
      try {
        const response = await api.post("/create-space-feed", formDatas);
        if (response.status === 200) {
          toast.success("Submitted Successfully");
          const role = localStorage.getItem("role");
          setTimeout(() => {
            navigate(role === "Guest" ? "/" : "/provider-listing");
          }, 2000);
        }
      } catch (error) {
        console.log(error, "error");
        toast.error("Something went wrong");
      } finally {
        setLoading(false);
      }
    }
    setLoading(false);
    setIsSubmitting(false);
  };
  */
  useEffect(() => {
    if (params?.type !== "new") {
      if (!!Object.values(providerDetail).length) {
        setTemp(true);
        setImagesURL(providerDetail?.spaceFeedMedia);
      }
    }
  }, [loadingState]);

  const handleKeepOnClick = () => {
    fileInputRef.current.click();
  };

  return (
    <>
      <div className="col-md-9">
        <div className="m-5">
          <div className="card">
            <div className="card-header">
              <h5 className="bold">Property Details</h5>
            </div>
            <div className="card-body">
              <span>Photos and Videos</span>
              <br />
              <span>
                Click below to upload photos and videos. Media will display in
                order
              </span>

              <div className="container d-flex justify-content-center w-100">
                <div className="filed">
                  <div className="upload-part m-5">
                    <div className="form-group file-area">
                      <input
                        type="file"
                        name="images"
                        id="images"
                        required="required"
                        accept="image/png,image/jpeg,image/jpg,video/mp4,video/quicktime"
                        multiple // Allow multiple file selection
                        onChange={handleFileChange} // Handle file selection
                        ref={fileInputRef}
                      />

                      <div className="file-dummy">
                        {images.length > 0 && (
                          <div className="success">
                            {`Great, you have selected ${images.length} files.`}
                            <span
                              style={{ color: "red", cursor: "pointer" }}
                              onClick={handleKeepOnClick}
                            >
                              {" "}
                              Keep on.
                            </span>
                          </div>
                        )}
                        <div className="default">
                          <div className="image-block mb-2">
                            {/* Icon of the image Uploader */}
                            <img src={UploadIcon} alt="icon" />
                          </div>
                          <span style={{ fontWeight: "600" }}>
                            Add Photos/Videos
                          </span>{" "}
                          <br />
                          <span>Click or drag and drop to add files</span>
                        </div>
                      </div>
                    </div>
                    {errors.images && (
                      <div className="text-danger">{errors.images}</div>
                    )}
                  </div>
                </div>
              </div>
              <ImagePreview imagesURL={imagesURL} setImagesURL={setImagesURL} />

              {isGuest && (
                <div className="mt-4">
                  <h6 className="bold">Contact Information</h6>
                  <p className="text-muted">Since you're posting without an account, please provide your contact details.</p>
                  <div className="row">
                    <div className="form-group col-md-6">
                      <label className="form-label" htmlFor="contactEmail">
                        Email Address<span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="contactEmail"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      {errors.email && (
                        <div className="text-danger">{errors.email}</div>
                      )}
                    </div>
                    <div className="form-group col-md-6">
                      <label className="form-label" htmlFor="contactPhone">
                        Phone Number<span className="text-danger">*</span>
                      </label>
                      <input
                        type="tel"
                        className="form-control"
                        id="contactPhone"
                        placeholder="Enter your phone number"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                      />
                      {errors.phone && (
                        <div className="text-danger">{errors.phone}</div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              <div className="d-flex justify-content-end descriptionButton">
                <button
                  disabled={loading ? true : false}
                  // className="mt-5 "
                  type="button"
                  className="mt-5 primary-btn"
                  onClick={handleSubmit}
                >
                  {loading ? "Submitting..." : "Submit"}{" "}
                  <span className="bold"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PropertyFileUploadForm;
